<template lang="pug">
  #Historial
    Header

    //- ── Breadcrumb ─────────────────────────────────────────────────────────
    div.breadcrumb-bar
      v-container(fluid)
        v-row(justify='center')
          v-col(cols='11')
            div.breadcrumb-inner
              a.bread-link(href='/') Inicio
              span.bread-sep /
              span.bread-current Historial de pedidos

    //- ── Contenido ──────────────────────────────────────────────────────────
    div.hist-page
      v-container(fluid)
        v-row(justify='center')
          v-col(cols='12' sm='11' md='11')

            //- Barra búsqueda
            div.hist-toolbar
              div.hist-search
                v-icon.hist-search-icon mdi-magnify
                input.hist-search-input(
                  v-model='search'
                  placeholder='Buscar pedido...'
                  @keyup.enter='initialize()'
                )
                v-btn.hist-search-btn(@click='initialize()').elevation-0 Buscar
              span.hist-count(v-if='totalO') {{ordenes.length}} de {{totalO}} pedidos
              div.hist-toolbar-actions
                v-btn(small depressed color='#1d6f42' dark @click='exportarExcelSeleccionados()' :disabled='seleccionados.length === 0')
                  v-icon(small left) mdi-microsoft-excel
                  | Excel ({{seleccionados.length}})

            //- Tabla
            div.hist-table

              //- Header (desktop)
              div.hist-thead(v-if='pantalla >= 820')
                div.hist-check-cell
                  v-checkbox(v-model='todosSeleccionados' hide-details dense @change='toggleTodos' style='margin:0;padding:0;')
                span(style='flex:1.5') Código
                span(style='flex:2') Fecha
                span(style='flex:1;text-align:center') Monto
                span(style='flex:1.5;text-align:center') Estatus
                span(style='width:60px')

              //- Skeleton loader
              div(v-if='loading && ordenes.length === 0')
                div.hist-row(v-for='i in 6' :key='i')
                  v-skeleton-loader(type='text' width='100%')

              //- Filas mobile
              div.hist-row-mobile(
                v-for='item in ordenes'
                :key='item._id + "m"'
                v-if='pantalla < 820'
                @click='editItem(item)'
              )
                div.hist-row-mobile-info
                  span.hist-order-num # {{item.doc_num}}
                  span.hist-order-date {{item.fec_emis | moment("DD-MM-YYYY, h:mm a")}}
                  span.hist-order-total ${{item.total_neto}}
                div.hist-row-mobile-right
                  div(:class='statusClass(item.status)') {{compararE(item.status)}}
                  v-icon(size='18' color='#c0c8d8') mdi-chevron-right

              //- Filas desktop
              div.hist-row(
                v-for='item in ordenes'
                :key='item._id'
                v-if='pantalla >= 820'
                :class="{ 'hist-row--sel': seleccionados.includes(item._id) }"
              )
                div.hist-check-cell
                  v-checkbox(v-model='seleccionados' :value='item._id' hide-details dense style='margin:0;padding:0;')
                span.hist-cell-code # {{item.doc_num}}
                span.hist-cell-date {{item.fec_emis | moment("DD-MM-YYYY, h:mm a")}}
                span.hist-cell-amount ${{item.total_neto}}
                div.hist-cell-status
                  span(:class='statusClass(item.status)') {{compararE(item.status)}}
                div.hist-cell-action
                  v-btn(icon small @click='editItem(item)').elevation-0
                    v-icon(size='18' color='#8a94a6') mdi-eye-outline

              //- Vacío
              div.hist-empty(v-if='!loading && ordenes.length === 0')
                v-icon(size='56' color='#d0d5e0') mdi-clipboard-text-off-outline
                span No tienes pedidos registrados

            //- Ver más / loading
            div.hist-footer
              v-progress-circular(v-if='loading && ordenes.length > 0' indeterminate size='28' width='2' color='#FF6200')
              v-btn(
                v-if='!loading && ordenes.length !== totalO'
                @click='verM()'
                class='hist-btn-more'
              ).elevation-0
                v-icon(left size='16') mdi-chevron-down
                | Ver más pedidos

    //- ── Modal detalle ───────────────────────────────────────────────────────
    v-dialog(v-model='dialog' persistent max-width='680px' scrollable)
      v-card(flat style='border-radius:12px;overflow:hidden;')
        div.hm-top-bar
        v-card-text(style='padding:0;')
          div.hm-body
            div.hm-header
              img.hm-logo(src='../assets/imgFerco/logo2.png')
              div.hm-header-right
                div.hm-badge PEDIDO
                div.hm-nro {{form.doc_num}}
            div.hm-meta-grid
              div.hm-meta-item
                div.hm-meta-label Fecha
                div.hm-meta-val(v-if='form.fec_emis') {{form.fec_emis | moment('DD/MM/YYYY HH:mm')}}
                div.hm-meta-val(v-else) —
              div.hm-meta-item(v-if='form.vendedor')
                div.hm-meta-label Vendedor
                div.hm-meta-val {{form.vendedor}}
              div.hm-meta-item
                div.hm-meta-label Estatus
                div.hm-meta-val
                  span(:class='statusClass(form.status)') {{compararE(form.status)}}
          div.hm-table
            div.hm-table-head
              div Producto
              div.hm-col-sm Código
              div.hm-col-sm Modelo
              div.hm-col-sm Ref
              div Cant.
              div Precio unit.
              div Subtotal
            div.hm-table-body
              div.hm-table-row(v-for='(item, i) in form.renglones' :key='i' :class="{ 'hm-row-alt': i % 2 !== 0 }")
                div.hm-col-name {{item.articulo ? item.articulo.art_des : item.des_art}}
                div.hm-col-sm.hm-col-meta {{item.co_art ? item.co_art.trim() : '—'}}
                div.hm-col-sm.hm-col-meta {{item.articulo && item.articulo.modelo ? item.articulo.modelo : '—'}}
                div.hm-col-sm.hm-col-meta {{item.articulo && item.articulo.ref ? item.articulo.ref : '—'}}
                div.hm-col-qty
                  span {{item.total_art}}
                div.hm-col-price ${{item.prec_vta != null ? item.prec_vta : '—'}}
                div.hm-col-price ${{item.reng_neto}}
          div.hm-total-bar
            span Total del pedido
            span ${{form.total_neto}}
        v-divider
        v-card-actions(style='padding:12px 16px;')
          v-btn(depressed color='#1d6f42' dark small @click='exportarExcelPedido()' style='text-transform:none;letter-spacing:0;border-radius:8px;')
            v-icon(left small) mdi-microsoft-excel
            | Excel
          v-spacer
          v-btn(depressed @click='close()' style='text-transform:none;letter-spacing:0;border-radius:8px;')
            v-icon(left small) mdi-close
            | Cerrar

    //- ── Modal espera ───────────────────────────────────────────────────────
    v-dialog(v-model='loading2' persistent max-width='320px')
      div.hist-loading-modal
        v-progress-circular(indeterminate size='48' width='3' color='#FF6200')
        span Cargando pedido...

    Footer
</template>

<script>
import Footer from '@/components/Footer.vue'
import Header from '@/components/Header.vue'
import Api from '@/services/methods'
import Swal from 'sweetalert2/dist/sweetalert2.min.js'
import { mapState, mapActions } from 'vuex'
import { serverImg } from '@/services/environment'
import * as XLSX from 'xlsx'
export default {
  name: 'Historial',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      search: '',
      loading2: false,
      loading: false,
      skip: 0,
      form: {
        cliente: '',
        doc_num: '',
        fec_emis: '',
        renglones: [],
        status: '',
        total_neto: 0,
        vendedor: ''
      },
      totalO: '',
      dialog: false,
      defaultForm: {
        cliente: '',
        doc_num: '',
        fec_emis: '',
        renglones: [],
        status: '',
        total_neto: 0,
        vendedor: ''
      },
      pantalla: screen.width,
      ruta: serverImg,
      ordenes: [],
      seleccionados: [],
      todosSeleccionados: false
    }
  },
  created () {
    this.initialize()
    document.documentElement.scrollTop = 0
  },
  methods: {
    compararE (data) {
      if (data === '0') return 'Creado'
      if (data === '1') return 'Pendiente'
      if (data === '2') return 'Procesado'
    },
    statusClass (data) {
      if (data === '0') return 'hist-status hist-status--creado'
      if (data === '1') return 'hist-status hist-status--pendiente'
      if (data === '2') return 'hist-status hist-status--procesado'
      return 'hist-status'
    },
    comparar (data) {
      if ((data + 1) === this.form.renglones.length) {
        return true
      } else {
        return false
      }
    },
    par (data) {
      if (data % 2 === 0) {
        return false
      } else {
        return true
      }
    },
    editItem (item) {
      Object.keys(this.form).forEach(key => {
        if (item[key] !== undefined) this.form[key] = item[key]
      })
      this.form._id = item._id
      this.dialog = true
    },
    toggleTodos (val) {
      this.seleccionados = val ? this.ordenes.map(o => o._id) : []
    },
    exportarExcelSeleccionados () {
      const selected = this.ordenes.filter(o => this.seleccionados.includes(o._id))
      const rows = []
      selected.forEach(o => {
        const renglones = o.renglones || []
        renglones.forEach(r => {
          rows.push({
            Pedido: o.doc_num,
            Fecha: o.fec_emis ? this.$moment(o.fec_emis).format('DD/MM/YYYY HH:mm') : '-',
            Estatus: this.compararE(o.status) || o.status,
            Código: r.co_art ? r.co_art.trim() : '',
            Producto: r.articulo ? r.articulo.art_des : (r.des_art || ''),
            Modelo: r.articulo ? (r.articulo.modelo || '') : '',
            Ref: r.articulo ? (r.articulo.ref || '') : '',
            Cantidad: r.total_art,
            'Precio unit.': r.prec_vta != null ? r.prec_vta : '',
            Subtotal: r.reng_neto
          })
        })
        rows.push({ Pedido: o.doc_num, Fecha: '', Estatus: '', Código: '', Producto: '', Modelo: '', Ref: '', Cantidad: 'TOTAL', 'Precio unit.': '', Subtotal: o.total_neto })
        rows.push({})
      })
      const ws = XLSX.utils.json_to_sheet(rows)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Pedidos')
      XLSX.writeFile(wb, 'Pedidos-seleccionados.xlsx')
    },
    exportarExcelPedido () {
      const f = this.form
      const rows = (f.renglones || []).map(r => ({
        Código: r.co_art ? r.co_art.trim() : '',
        Producto: r.articulo ? r.articulo.art_des : (r.des_art || ''),
        Modelo: r.articulo ? (r.articulo.modelo || '') : '',
        Ref: r.articulo ? (r.articulo.ref || '') : '',
        Cantidad: r.total_art,
        'Precio unit.': r.prec_vta != null ? r.prec_vta : '',
        Subtotal: r.reng_neto
      }))
      rows.push({ Código: '', Producto: '', Modelo: '', Ref: '', Cantidad: 'TOTAL', 'Precio unit.': '', Subtotal: f.total_neto })
      const ws = XLSX.utils.json_to_sheet(rows)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Pedido')
      XLSX.writeFile(wb, 'Pedido-' + (f.doc_num || 'detalle') + '.xlsx')
    },
    close () {
      this.form = Object.assign({}, this.defaultForm)
      this.dialog = false
      // this.initialize();
    },
    verM () {
      this.loading = true
      Api.get('pedidosCom/cli/' + this.$store.state.fercoWeb.co_cli + '?skip=' + this.skip + '&busqueda=' + this.search).then(res => {
        for (let i = 0; i < res.data.length; i++) {
          this.ordenes.push(res.data[i])
        }
        this.loading = false
        this.skip += 10
      }).catch(err => {
        this.loading = false
        console.log(err)
        Swal.fire(
          'Error inesperado',
          'Problemas de conexión, por favor inténtelo nuevamente.',
          'error'
        )
      })
    },
    initialize () {
      if (this.$store.state.fercoWeb.co_cli) {
        this.skip = 0
        this.loading = true
        Api.get('pedidosCom/cli/' + this.$store.state.fercoWeb.co_cli + '?skip=' + this.skip + '&busqueda=' + this.search).then(res => {
          this.ordenes = res.data
          this.skip += 10
          this.loading = false
        }).catch(err => {
          this.loading = false
          console.log(err)
        })
        Api.get('pedidosCom/cliCont/' + this.$store.state.fercoWeb.co_cli + '?busqueda=' + this.search).then(res => {
          this.totalO = res.data
        })
      }
    }
  }
}
</script>
<style lang="scss">
@import "~@/assets/scss/historial.scss";
</style>
